import { render, staticRenderFns } from "./ChemOleMissLab8_Task1.vue?vue&type=template&id=d0f646ea&"
import script from "./ChemOleMissLab8_Task1.vue?vue&type=script&lang=ts&"
export * from "./ChemOleMissLab8_Task1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
